/**
 * Стандартные шаблоны приглашений (включены в базовый пакет)
 */
export const STANDARD_TEMPLATES = [
  { value: 'classic', label: 'Классический', description: 'Традиционный элегантный дизайн' },
  { value: 'modern', label: 'Современный', description: 'Минималистичный современный стиль' },
  { value: 'romantic', label: 'Романтический', description: 'Нежный романтический дизайн' },
  { value: 'vintage', label: 'Винтажный', description: 'Теплые коричневые тона, ретро стиль' },
  { value: 'minimal', label: 'Минималистичный', description: 'Чистые линии, простые формы' },
  { value: 'garden', label: 'Садовый', description: 'Свежие зеленые тона, природные акценты' },
] as const;

/**
 * Тип шаблона
 */
type Template = {
  readonly value: string;
  readonly label: string;
  readonly description: string;
};

/**
 * Премиум шаблоны приглашений (требуют дополнительной подписки)
 */
export const PREMIUM_TEMPLATES: readonly Template[] = [
  {
    value: 'charming-natural',
    label: 'Charming Natural',
    description: 'Элегантный дизайн с цветочным фоном и классической типографикой',
  },
] as const;

/**
 * Все доступные шаблоны
 */
export const TEMPLATES = [...STANDARD_TEMPLATES, ...PREMIUM_TEMPLATES] as const;

/**
 * Тип значения шаблона
 */
export type TemplateValue = typeof TEMPLATES[number]['value'];

/**
 * Валидные значения шаблонов
 */
export const VALID_TEMPLATES: readonly TemplateValue[] = TEMPLATES.map((t) => t.value);

/**
 * Валидные значения стандартных шаблонов
 */
export const VALID_STANDARD_TEMPLATES: readonly TemplateValue[] = STANDARD_TEMPLATES.map((t) => t.value);

/**
 * Валидные значения премиум шаблонов
 */
export const VALID_PREMIUM_TEMPLATES: readonly TemplateValue[] = PREMIUM_TEMPLATES.map((t) => t.value);

/**
 * Шаблон по умолчанию
 */
export const DEFAULT_TEMPLATE: TemplateValue = 'classic';

/**
 * Проверка, является ли шаблон стандартным
 */
export const isStandardTemplate = (template: string): boolean => (
  VALID_STANDARD_TEMPLATES.includes(template as TemplateValue)
);

/**
 * Проверка, является ли шаблон премиум
 */
export const isPremiumTemplate = (template: string): boolean => (
  VALID_PREMIUM_TEMPLATES.includes(template as TemplateValue)
);
